module.exports = __webpack_public_path__ + "static/img/Youling.3dd5be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Youling.jpg
// module id = uOLJ
// module chunks = 1